var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Candidate',{attrs:{"source":_vm.resume,"isResume":false}}),_c('div',[_vm._v("教育经历")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }